/**
 * Coordination des Volets (AccordionPanel) « une seule ouverte à la fois » :
 * registre module par instance de rendu (iframe éditeur / viewer — chaque
 * bundle a le sien). Un volet exclusif notifie à son ouverture ; les autres
 * volets exclusifs abonnés se ferment (les indépendants ignorent).
 */

const listeners = new Set();

/** @param {(openedPanelId: string) => void} listener @returns {() => void} */
export function subscribeAccordionPanels(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyExclusivePanelOpened(panelId) {
  listeners.forEach((listener) => listener(panelId));
}

/**
 * Canal éditeur : la sidebar demande au volet sélectionné de basculer
 * ouvert/fermé (aperçu de l'état fermé) — l'état d'ouverture est local au
 * composant canvas, pas une prop persistée.
 */
const previewToggleListeners = new Set();

export function subscribePanelPreviewToggle(listener) {
  previewToggleListeners.add(listener);
  return () => previewToggleListeners.delete(listener);
}

export function notifyPanelPreviewToggle(panelId) {
  previewToggleListeners.forEach((listener) => listener(panelId));
}
